import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { Table } from "primeng/table";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { AppConfigService } from "../../../app.config.service";

@Component({
    selector: "table-filter",
    templateUrl: "./table-filter.component.html",
    styleUrls: ["./table-filter.component.scss"],
})
export class TableFilterComponent implements OnInit, OnDestroy {
    @Input() filter: any;
    @Input() table: Table;
    @Input() last = false;
    @ViewChild("multi") multi;
    @Output() onChange = new EventEmitter();
    data = [];
    operators = [
        { label: ">=", value: "gte" },
        { label: "<=", value: "lte" },
        { label: ">", value: "gt" },
        { label: "<", value: "lt" },
    ];
    maxDate;
    rangeDates: any;
    yearRange: any;
    ngUnsubscribe = new Subject();
    now = new Date();
    multiSelected: any = [];
    singleDateTime: Date | null = null;
    dataTypes = {
        yesNo: [
            { label: this.translate.instant("Evet"), value: 1 },
            { label: this.translate.instant("Hayır"), value: 0 },
        ],
        activePassive: [
            { label: this.translate.instant("Aktif"), value: 1 },
            { label: this.translate.instant("Pasif"), value: 0 },
        ],
        passiveActive: [
            { label: this.translate.instant("Aktif"), value: 0 },
            { label: this.translate.instant("Pasif"), value: 1 },
        ],
        configTypes: [
            { label: this.translate.instant("common"), value: "common" },
            {
                label: this.translate.instant("system"),
                value: "system",
            },
        ],
        optionDataTypes: [
            { label: this.translate.instant("string"), value: "string" },
            { label: this.translate.instant("number"), value: "number" },
            { label: this.translate.instant("boolean"), value: "boolean" },
            { label: this.translate.instant("media"), value: "media" },
            { label: this.translate.instant("json"), value: "json" },
        ],
        paymentStatuses: [
            { label: this.translate.instant("Tamamlandı"), value: 1 },
            {
                label: this.translate.instant("Bekleyen"),
                value: 0,
            },
            { label: this.translate.instant("İptal"), value: -1 },
        ],
        receiptStatuses: [
            { label: this.translate.instant("Ödendi"), value: 1 },
            {
                label: this.translate.instant("Bekleyen"),
                value: 0,
            },
            { label: this.translate.instant("İptal"), value: -1 },
        ],
        userStatuses: [
            { label: this.translate.instant("Aktif"), value: "active" },
            { label: this.translate.instant("Bekleyen"), value: "pending" },
            { label: this.translate.instant("Ban"), value: "ban" },
            { label: this.translate.instant("Pasif"), value: "passive" },
        ],
        optionPermission: [
            { label: this.translate.instant("root"), value: "root" },
            { label: this.translate.instant("sub"), value: "sub" },
            { label: this.translate.instant("all"), value: "all" },
        ],
        optionType: [
            { label: this.translate.instant("common"), value: "common" },
            { label: this.translate.instant("reseller"), value: "reseller" },
            { label: this.translate.instant("user"), value: "user" },
        ],
        gameProviders: [
            { label: "GrandX", value: "grandX" },
            { label: "Timeless", value: "timeless" },
            { label: "Gamingconstruct", value: "gamingconstruct" },
            { label: "MegaRgs", value: "megargs" },
        ],
        logStatuses: [
            { label: "Info", value: 200 },
            { label: "Warning", value: 300 },
            { label: "Error", value: 400 },
        ],
        campaignReports: [
            { label: "Sms", value: 0 },
            { label: "Email", value: 1 },
        ],
        recipientStatus: [
            { label: "Subscribe", value: 1 },
            { label: "Unsubscribe", value: 0 },
        ],
        recipientListStatus: [
            { label: "Active", value: 1 },
            { label: "Disable", value: 0 },
        ],
        withdrawStatuses: [
            { label: this.translate.instant("Bekleyen"), value: 1 },
            { label: this.translate.instant("Tamamlandı"), value: 2 },
            { label: this.translate.instant("İptal"), value: 3 },
            { label: this.translate.instant("İşlem"), value: 4 },
            { label: this.translate.instant("Talep"), value: 5 },
        ],
        depositStatuses: [
            { label: this.translate.instant("Tamamlandı"), value: 2 },
            { label: this.translate.instant("Bekleyen"), value: 1 },
            { label: this.translate.instant("İptal"), value: 3 },
        ],
    };
    selectAll = false;

    quickDatePreset: string | null = null;
    quickDateCustomFrom: Date | null = null;
    quickDateCustomTo: Date | null = null;
    quickDateCustomFromTime: Date | null = null;
    quickDateCustomToTime: Date | null = null;
    quickDateLabel = '';
    quickDateMaxDate: Date | null = null;
    quickDatePresets = [
        { label: 'Today',      value: 'today' },
        { label: 'Yesterday',  value: 'yesterday' },
        { label: 'This Week',  value: 'thisWeek' },
        { label: 'Last Week',  value: 'lastWeek' },
        { label: 'This Month', value: 'thisMonth' },
        { label: 'Last Month', value: 'lastMonth' },
        { label: 'This Year',  value: 'thisYear' },
        { label: 'Last Year',  value: 'lastYear' },
    ];

    constructor(
        public configService: AppConfigService,
        public translate: TranslateService
    ) {}

    ngOnInit() {
        switch (this.filter.matchMode) {
            case "single":
            case "multi":
                if (this.filter.dataType) {
                    this.loadMultiData(this.filter.dataType);
                } else {
                    if (!this.filter.data) {
                        return;
                    }
                    this.checkSelected();
                    // Check if data is directly an array (for simple single selects)
                    if (Array.isArray(this.filter.data)) {
                        this.data = this.filter.data;
                        return;
                    }
                    if (this.filter.data.hasOwnProperty("data")) {
                        this.data = this.filter.data.data;
                        return;
                    }
                    this.filter.data.observable.subscribe((data) => {
                        this.data = [];
                        console.warn(data.data);
                        if (data.data) {
                            let newData = [];
                            if (!this.filter.data.resellerSpecial) {
                                if (this.filter.data.startsWith) {
                                    this.data = [
                                        ...this.filter.data.startsWith,
                                    ];
                                }
                                newData = data.data.map((filter) => {
                                    const rawLabel = filter[this.filter.data.label];
                                    let translatedName: any = rawLabel;
                                    // If translate flag is set, try language-specific fallbacks
                                    if (this.filter.data.translate) {
                                        if (rawLabel && typeof rawLabel === 'object') {
                                            const lang = this.translate.currentLang;
                                            translatedName = rawLabel[lang] || rawLabel['en'];
                                            if (!translatedName) {
                                                // pick first non-empty value
                                                const firstNonEmpty = Object.values(rawLabel).find((v: any) => !!v && String(v).trim() !== '');
                                                translatedName = firstNonEmpty || '';
                                            }
                                        }
                                    }
                                    if (!translatedName || String(translatedName).trim() === '') {
                                        translatedName = `Market ${filter[this.filter.data.value]}`;
                                    }

                                    return {
                                        label: translatedName + (this.filter.data.infoLabel ? " (" + filter[this.filter.data.infoLabel] + ")" : ""),
                                        value: filter[this.filter.data.value],
                                    };
                                });
                            } else {
                                newData = this.buildResellerSpecial(data.data);
                            }

                            if (this.filter.data.distinct) {
                                const seen = new Set();
                                newData = newData.filter((item) => {
                                    if (seen.has(item.value)) {
                                        return false;
                                    }
                                    seen.add(item.value);
                                    return true;
                                });
                            }

                            this.data = [...this.data, ...newData];
                            try {
                                if (this.filter && this.filter.label) {
                                } else {
                                }
                            } catch (e) {}
                        }
                    });
                }
                break;
            case "dateRange":
                const now = new Date();
                this.yearRange = "1970:2030";
                if (this.filter.maxDate) {
                    this.yearRange = "1970:" + now.getFullYear();
                    this.maxDate = new Date(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate() + 1,
                        23,
                        59,
                        59,
                        999
                    );
                }
                if (this.filter.startDate) {
                    const startDate = this.getDate(this.filter.startDate);
                    // Set end date to today (end of day) to create a complete date range
                    const endDate = new Date(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate(),
                        23,
                        59,
                        59,
                        999
                    );
                    this.rangeDates = [startDate, endDate];
                    // Use filterTable instead of setFilter to ensure proper validation and formatting
                    this.filterTable(this.rangeDates, "dateRange");
                }
                break;
            case 'quickDate':
                this.quickDateLabel = this.filter.label || 'Date';
                if (this.filter.maxDate) {
                    this.quickDateMaxDate = new Date();
                }
                if (this.filter.defaultPreset) {
                    this.initQuickPreset(this.filter.defaultPreset);
                }
                break;
            case "date":
            case "dateTimeFrom":
            case "dateTimeTo":
                const current = new Date();
                this.yearRange = "1970:2030";
                if (this.filter.maxDate) {
                    this.yearRange = "1970:" + current.getFullYear();
                    this.maxDate = new Date(
                        current.getFullYear(),
                        current.getMonth(),
                        current.getDate() + 1,
                        23,
                        59,
                        59,
                        999
                    );
                }
                break;
        }
        if (this.last && !this.table.lazyLoadOnInit) {
            this.table.onLazyLoad.emit(this.table.createLazyLoadMetadata());
        }
    }

    private loadMultiData(dataType: any) {
        this.data = [];
        switch (dataType) {
            case "walletTypes":
            case "couponTypes":
            case "eventTypes":
            case "bonusTypes":
            case "couponStatuses":
            case "accountStatuses":
            case "statuses":
            case "bannerKeys":
            case "transactionTypeCategories":
            case "transactionTypes":
            case "userLimitTypes":
            case "rslProgressPaymentTypes":
            case "logCategories":
            case "rslTransactionTypes":
            case "empTransactionTypes":
            case "promotionTypes":
            case "eventStatuses":
                this.data = [...this.configService.getFilters(dataType)];
                this.checkSelected();
                break;
            case "yesNo":
            case "activePassive":
            case "passiveActive":
            case "logStatuses":
            case "campaignReports":
            case "FooterName":
            case "recipientStatus":
            case "recipientListStatus":
            case "optionDataTypes":
            case "configTypes":
            case "paymentStatuses":
            case "withdrawStatuses":
            case "depositStatuses":
            case "receiptStatuses":
            case "userStatuses":
            case "gameProviders":
                this.data = this.dataTypes[dataType];
                this.checkSelected();
                break;
            case "optionPermission":
                this.data = this.dataTypes[dataType];
                break;
            case "optionType":
                this.data = this.dataTypes[dataType];
                break;
        }
    }

    filterTable(inputValue, matchMode) {
        let value = inputValue;
        const field = this.filter.field;

        const isEmpty =
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0);

        if (isEmpty) {
            // Clear this field's filter fully and trigger lazy load
            this.table.filter(null, field, matchMode);
            this.onChange.emit({ field, value: null, type: 'clear' });
            return;
        }

        if (matchMode === 'dateRange' && value && Array.isArray(value)) {
            // Guard: ignore until both dates are selected
            if (value.length < 2 || !value[0] || !value[1]) {
                return; // avoid firing API with half range
            }
            if (value.length === 2) {
                let startDate = new Date(value[0]);
                let endDate = new Date(value[1]);
    
                if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                    console.error("Invalid date range provided:", value);
                    return;
                }

                // Ensure chronological order regardless of selection order
                if (startDate.getTime() > endDate.getTime()) {
                    const tmp = startDate;
                    startDate = endDate;
                    endDate = tmp;
                }
                
                // Ensure proper timezone handling and end-of-day logic
                // If no specific time was selected, set start to beginning of day and end to end of day
                const startTime = startDate.getHours() === 0 && startDate.getMinutes() === 0 && startDate.getSeconds() === 0;
                const endTime = endDate.getHours() === 0 && endDate.getMinutes() === 0 && endDate.getSeconds() === 0;
                
                if (startTime) {
                    startDate.setHours(0, 0, 0, 0);
                }
                if (endTime) {
                    endDate.setHours(23, 59, 59, 999);
                } else {
                    // If end time has specific hours/minutes but no seconds, set seconds to 59
                    if (endDate.getSeconds() === 0 && endDate.getMilliseconds() === 0) {
                        endDate.setSeconds(59, 999);
                    }
                }

                // Convert user's local time to UTC for backend compatibility
                value = [
                    this.formatDateTimeLocal(startDate),
                    this.formatDateTimeLocal(endDate)
                ];
            }
            // Use the exact format requested: {prefix: "coupon", value: [start, end]}
            value = this.filter.join
                ? { prefix: this.filter.join, value: value }
                : value;
        } else {
            value = this.filter.join
                ? { prefix: this.filter.join, value: inputValue }
                : inputValue;
        }
    
        this.table.filter(value, field, matchMode);
        this.onChange.emit({ field, value, matchMode });
    }

    filterDate(value: Date | string | null) {
        // p-calendar has dataType="string", so the bound model value is already
        // a formatted "yyyy-mm-dd" string, not a Date instance.
        const formatted = value ? (typeof value === 'string' ? value : this.formatDateOnly(value)) : null;
        this.filterTable(formatted, 'equals');
    }

    private formatDateOnly(date: Date): string {
        const pad = (n: number) => n < 10 ? `0${n}` : `${n}`;
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    filterDateTime(value: Date | null, mode: string) {
        if (!value) {
            this.onChange.emit({ field: this.filter.field, value: null, type: mode });
            return;
        }
        const formatted = this.formatDateTimeLocal(value);
        this.onChange.emit({ field: this.filter.field, value: formatted, type: mode });
    }

    clearDateTime(mode: string) {
        this.singleDateTime = null;
        this.onChange.emit({ field: this.filter.field, value: null, type: mode });
    }

    private formatDateTimeLocal(date: Date): string {
        if (!date) { return null; }
        const pad = (n: number) => n < 10 ? `0${n}` : `${n}`;
        const local = new Date(date);
        return `${local.getFullYear()}-${pad(local.getMonth() + 1)}-${pad(local.getDate())} ` +
            `${pad(local.getHours())}:${pad(local.getMinutes())}:${pad(local.getSeconds())}`;
    }

    filterRange(fromValue: string, toValue: string) {
        const field = this.filter.field;
        const from = fromValue && fromValue.trim() !== '' ? Number(fromValue) : null;
        const to = toValue && toValue.trim() !== '' ? Number(toValue) : null;
        
        console.log('Range filter applied:', { field, from, to, label: this.filter.label });
        
        // Emit the range filter event to parent component
        this.onChange.emit({ 
            field, 
            value: { from, to },
            type: 'range'
        });
    }

    // Allow manual typing in calendar input: parse "YYYY-MM-DD HH:mm[:ss] - YYYY-MM-DD HH:mm[:ss]"
    onDateInput(event: any) {
        if (!event || !event.target) { return; }
        const raw: string = (event.target.value || '').trim();
        if (!raw) { return; }
        const parts = raw.split(' - ').map(p => p.trim()).filter(Boolean);
        if (parts.length !== 2) { return; }

        const parse = (txt: string): Date | null => {
            // Accept YYYY-MM-DD HH:mm or YYYY-MM-DD HH:mm:ss
            const re = /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})(?::(\d{2}))?$/;
            const m = re.exec(txt);
            if (!m) { return null; }
            const year = Number(m[1]);
            const month = Number(m[2]) - 1;
            const day = Number(m[3]);
            const hour = Number(m[4]);
            const minute = Number(m[5]);
            const second = m[6] !== undefined ? Number(m[6]) : 0;
            return new Date(year, month, day, hour, minute, second, 0);
        };

        let start = parse(parts[0]);
        let end = parse(parts[1]);
        if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) {
            return;
        }

        // Normalize order
        if (start.getTime() > end.getTime()) {
            const tmp = start;
            start = end;
            end = tmp;
        }

        // Keep calendar selection synced
        this.rangeDates = [start, end];
        this.filterTable(this.rangeDates, 'dateRange');
    }

    getFromPlaceholder(): string {
        const field = this.filter?.field;
        const fromKey = this.getRangePlaceholderKey(field, 'from');
        return this.translate.instant(fromKey);
    }

    getToPlaceholder(): string {
        const field = this.filter?.field;
        const toKey = this.getRangePlaceholderKey(field, 'to');
        return this.translate.instant(toKey);
    }

    private getRangePlaceholderKey(field: string, type: 'from' | 'to'): string {
        const placeholders: Record<string, { from: string; to: string }> = {
            count: { from: 'From Count', to: 'To Count' },
            winCount: { from: 'From Win', to: 'To Win' },
            loseCount: { from: 'From Lose', to: 'To Lose' },
            totalStake: { from: 'From Deposit', to: 'To Deposit' },
            potentialGain: { from: 'From Potential', to: 'To Potential' },
            gain: { from: 'From Earnings', to: 'To Earnings' },
            beforeBalance: { from: 'From Before Balance', to: 'To Before Balance' },
            afterBalance: { from: 'From After Balance', to: 'To After Balance' },
        };

        const fallback = { from: 'From', to: 'To' };
        const selected = placeholders[field] || fallback;
        return type === 'from' ? selected.from : selected.to;
    }
    
    
    
    

    selectQuickPreset(preset: string, panel?: any) {
        this.quickDatePreset = preset;
        this.quickDateCustomFrom = null;
        this.quickDateCustomTo = null;
        const found = this.quickDatePresets.find(p => p.value === preset);
        this.quickDateLabel = found ? found.label : preset;
        const { start, end } = this.getPresetRange(preset);
        this.applyQuickDateFilter(start, end);
        if (panel) { panel.hide(); }
    }

    applyQuickCustom(panel?: any) {
        if (!this.quickDateCustomFrom || !this.quickDateCustomTo) { return; }
        this.quickDatePreset = null;
        const start = this.combineDateAndTime(this.quickDateCustomFrom, this.quickDateCustomFromTime, 0, 0, 0);
        const end   = this.combineDateAndTime(this.quickDateCustomTo,   this.quickDateCustomToTime,   23, 59, 59);
        const pad = (n: number) => n < 10 ? `0${n}` : `${n}`;
        const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        this.quickDateLabel = `${fmt(start)} – ${fmt(end)}`;
        this.applyQuickDateFilter(start, end);
        if (panel) { panel.hide(); }
    }

    onQuickFromSelect() {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        this.quickDateCustomFromTime = d;
    }

    onQuickToSelect() {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        this.quickDateCustomToTime = d;
    }

    private combineDateAndTime(date: Date, time: Date | null, defaultH: number, defaultM: number, defaultS: number): Date {
        const result = new Date(date);
        if (time) {
            result.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), 0);
        } else {
            result.setHours(defaultH, defaultM, defaultS, 0);
        }
        return result;
    }

    clearQuickDate() {
        this.quickDatePreset = null;
        this.quickDateCustomFrom = null;
        this.quickDateCustomTo = null;
        this.quickDateCustomFromTime = null;
        this.quickDateCustomToTime = null;
        this.quickDateLabel = this.filter.label || 'Date';
        this.table.filter(null, this.filter.field, 'dateRange');
        this.onChange.emit({ field: this.filter.field, value: null, type: 'clear' });
    }

    private initQuickPreset(preset: string) {
        this.quickDatePreset = preset;
        const found = this.quickDatePresets.find(p => p.value === preset);
        this.quickDateLabel = found ? found.label : preset;
        const { start, end } = this.getPresetRange(preset);
        const value = [this.localToUTC(start), this.localToUTC(end)];
        const finalValue = this.filter.join
            ? { prefix: this.filter.join, value }
            : value;
        this.table.filters[this.filter.field] = { value: finalValue, matchMode: 'dateRange' };
    }

    private applyQuickDateFilter(start: Date, end: Date) {
        const value = [this.localToUTC(start), this.localToUTC(end)];
        const finalValue = this.filter.join
            ? { prefix: this.filter.join, value }
            : value;
        this.table.filter(finalValue, this.filter.field, 'dateRange');
        this.onChange.emit({ field: this.filter.field, value: finalValue, matchMode: 'dateRange' });
    }

    private getPresetRange(preset: string): { start: Date; end: Date } {
        const now = new Date();
        const tod = (h: number, m: number, s: number, ms: number) =>
            new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, s, ms);

        switch (preset) {
            case 'today':
                return { start: tod(0, 0, 0, 0), end: tod(23, 59, 59, 999) };
            case 'yesterday': {
                const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
                return {
                    start: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0),
                    end:   new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999),
                };
            }
            case 'thisWeek': {
                const day = now.getDay();
                const offset = day === 0 ? -6 : 1 - day;
                const mon = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
                return {
                    start: new Date(mon.getFullYear(), mon.getMonth(), mon.getDate(), 0, 0, 0, 0),
                    end:   tod(23, 59, 59, 999),
                };
            }
            case 'lastWeek': {
                const day = now.getDay();
                const offset = day === 0 ? -6 : 1 - day;
                const thisMon = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
                const lastMon = new Date(thisMon.getFullYear(), thisMon.getMonth(), thisMon.getDate() - 7);
                const lastSun = new Date(thisMon.getFullYear(), thisMon.getMonth(), thisMon.getDate() - 1);
                return {
                    start: new Date(lastMon.getFullYear(), lastMon.getMonth(), lastMon.getDate(), 0, 0, 0, 0),
                    end:   new Date(lastSun.getFullYear(), lastSun.getMonth(), lastSun.getDate(), 23, 59, 59, 999),
                };
            }
            case 'thisMonth':
                return {
                    start: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0),
                    end:   tod(23, 59, 59, 999),
                };
            case 'lastMonth':
                return {
                    start: new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0),
                    end:   new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999),
                };
            case 'thisYear':
                return {
                    start: new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0),
                    end:   tod(23, 59, 59, 999),
                };
            case 'lastYear':
                return {
                    start: new Date(now.getFullYear() - 1, 0, 1, 0, 0, 0, 0),
                    end:   new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999),
                };
            default:
                return { start: tod(0, 0, 0, 0), end: tod(23, 59, 59, 999) };
        }
    }

    private localToUTC(date: Date): string {
        const pad = (n: number) => n < 10 ? `0${n}` : `${n}`;
        return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ` +
            `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.ngUnsubscribe.unsubscribe();
    }

    private getDate(days) {
        return new Date(
            this.now.getFullYear(),
            this.now.getMonth(),
            this.now.getDate() + +days
        );
    }

    private buildResellerSpecial(data) {
        const parent = { value: 0, label: "" };
        if (this.filter.selected && this.filter.selected.length) {
            parent.value = this.filter.selected[0].parentId;
        }
        return this.checkHasChildren(parent, data);
    }

    private checkHasChildren(parent: any, data: any) {
        const resellers = [];

        data.forEach((reseller) => {
            if (reseller.parentId === parent.value) {
                const item = {
                    label: parent.label + reseller.username + " => ",
                    value: reseller.id,
                };
                const result = this.checkHasChildren(item, data);
                item.label = this.trimEnd(item.label, " => ");
                resellers.push(item);
                if (result.length) {
                    result.forEach((res) => {
                        res.label = this.trimEnd(res.label, " => ");
                        resellers.push(res);
                    });
                }
            }
        });
        return resellers;
    }

    trimEnd(str, charList) {
        return str.replace(new RegExp("[" + charList + "]+$"), "");
    }

    selectChange($event: any[]) {
        const search = $event.map((x) => {
            return x.value;
        });
        this.filterTable(search, "in");
    }

    toggleSelectAll() {
        const search = [];
        if (!this.selectAll) {
            const filteredItems = this.multi?.itemsList?.filteredItems;
            const source = filteredItems?.length ? 
                filteredItems.map(x => ({ value: x.value.value })) : 
                this.data.map(x => ({ value: x.value }));
            this.multiSelected = source.map((item: { value: any }) => {
                search.push(item.value);
                return item.value;
            });
        } else {
            this.multiSelected = [];
        }
        this.selectAll = !this.selectAll;

        this.filterTable(search, "in");
    }

    clearSelect($event: {}) {
        this.selectAll = false;
        this.multiSelected = [];
        const field = this.filter.field;
        // Clear the table's filter for this field and trigger reload
        this.table.filter(null, field, 'in');
        this.onChange.emit({ field, value: null, type: 'clear' });
    }

    private checkSelected() {
        if (this.filter.selected && this.filter.selected.length) {
            this.multiSelected = [this.filter.selected[0].id];
            this.setFilter(this.multiSelected, "in");
        }
    }

    private setFilter(inputValue: any, matchMode: string) {
        const value = this.filter.join
            ? { prefix: this.filter.join, value: inputValue }
            : inputValue;
        const field = this.filter.field;
        this.table.filters[field] = { value, matchMode };
    }
}
